// extracted by mini-css-extract-plugin
export default {"search":"PostFilter_search__1oYJg","sort":"PostFilter_sort__lZLE6"};